/* eslint-disable no-debugger */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import { CoreHelper, WithCoreProps, TranslationProps, ActionMetaService } from 'ff-shared-components-core';
import {
	Button,
	TitleContainer,
	OutputField,
	LinkLabel,
	RadioButton,
	FileField,
	FileUploadType,
	Table,
	Row,
	TableAppearance,
	ColType,
	TemporaryFile,
	modalOpen,
	BuildOkInfoModal,
	FileAction,
	Modal,
	BuildCustomMessageGenericErrorModal,
	PageScreen,
	FieldsFormContainer,
} from '@shared/components';
import { submitContractSchema, isPrivateNipc as checkIfIsPrivateNipc } from '@components';
import {
	StoreState,
	getRegisterPharmacyInputData,
	RegisterInputData,
	removeUserData,
	removeUploadFileExecution,
	fetchUploadFileExecutionRequest,
	fetchDownloadContractFileRequest,
	fetchDownloadRegisterDocumentByIdRequest,
	SubscriptionTypes,
	StepRegisterInputData,
} from '@store';
import { ProcessFlowState, getProcessFlow } from '@shared/processFlow';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './entityDataConfirmation.less';
import { Formik, Form, FormikValues, Field } from 'formik';
import { EnrollmentTypes } from '@api/ff-shared-services-api';
import { downloadFilePdf } from '@helpers';
import { FileUploadConfig } from '@config';

interface EntityDataConfirmationState {
	selectedUsers: any;
	selectedRadio?: SubscriptionTypes;
}

interface EntityDataConfirmationInnerProps {
	entityData: RegisterInputData;
	processFlow: ProcessFlowState;
}

interface EntityDataConfirmationProps {
	canEditUsers: boolean;
	onClickCreatingUser?(): void;
	onClickToViewUserDetail?: (row?: any) => void;
	onClickNext(data?: StepRegisterInputData): void;
	onClickBack(data: any): void;
	onClickCancel(): void;
	fetchUpdateRegisterData?: (registerData: StepRegisterInputData, successHandler?: () => void) => void;
}

interface EntityDataConfirmationInjectedProps extends TranslationProps {
	fetchUploadFileExecutionRequest: (fileData: FileUploadType, metaData?: ActionMetaService) => void;
	fetchDownloadContractFileRequest: (metaData?: ActionMetaService) => void;
	fetchDownloadRegisterDocumentByIdRequest: (fileId: string, metaData?: ActionMetaService) => void;
	removeUploadFileExecution: (currentStep: number) => void;
	removeUserData: (id: string) => void;
	modalOpen: (modal: Modal) => void;
}

type Props = EntityDataConfirmationProps & EntityDataConfirmationInjectedProps & EntityDataConfirmationInnerProps;

class EntityDataConfirmationScreenComponent extends React.PureComponent<Props, EntityDataConfirmationState> {
	public constructor(props: Props) {
		super(props);
		const { entityData } = this.props;

		this.state = {
			selectedRadio: entityData && entityData.subscription ? entityData.subscription : undefined,
			selectedUsers: [],
		};

		window.scrollTo(0, 0);
	}

	// public componentDidMount(): void {
	// 	const { entityData } = this.props;
	// 	if (entityData) {
	// 		this.setState({ selectedRadio: entityData.subscription ? entityData.subscription : '' });
	// 	}
	// }

	public render(): JSX.Element {
		const {
			onClickNext,
			onClickBack,
			onClickCancel,
			entityData,
			t,
			canEditUsers,
			onClickCreatingUser,
			onClickToViewUserDetail,
			fetchUploadFileExecutionRequest,
			modalOpen,
		} = this.props;
		const { selectedRadio } = this.state;

		//FILES
		const evidenceFile = entityData.proofInputFile ? entityData.proofInputFile : null;
		const ibanFile = entityData.ibanInputFile ? entityData.ibanInputFile : null;

		const headings: string[] = [
			t('table.registerPharmacy.header.userName'),
			t('table.registerPharmacy.header.userType'),
			t('table.registerPharmacy.header.email'),
		];
		const rows: Row[] = [];

		entityData.usersData &&
			entityData.usersData.forEach(u => {
				//debugger;
				const row: Row = {
					// id: u.idDocumentNumber,
					id: u.id ? u.id : '0',
					columns: [
						{ value: u.shortName },
						{
							value:
								u.profileAccess === EnrollmentTypes.UserProfile.AUTHORIZED
									? t<string>('radioButtons.userData.signer')
									: t<string>('radioButtons.userData.operator'),
						},
						{ value: u.email },
					],
					// isSelected: this.isRowSelected(u.idDocumentNumber),
					isSelected: this.isRowSelected(u.id ? u.id : '0'),
				};
				rows.push(row);
			});

		return (
			// <div id="page-entity-data-confirmation" className="page-entity-data-confirmation">

			<PageScreen name="page-entity-data-confirmation">
				{/* <div className="registerPharmacy-container entity-data-confirmation-container"> */}
				<p className="ds-heading2-light" style={{ marginBottom: '5.5rem', marginTop: '5.5rem' }}>
					{t('titleContainer.entityData.entityData')}
				</p>
				<div className="bottom-88pt">
					<FieldsFormContainer>
						<TitleContainer
							text={t('titleContainer.entityData.generalData')}
							content={(): React.ReactNode => (
								<>
									<OutputField
										outputLabel={t('label.nipc')}
										outputText={entityData.nipc ? entityData.nipc : ''}
									/>
									<OutputField
										outputLabel={t('label.entityName')}
										outputText={entityData.entityName ? entityData.entityName : ''}
									/>
									<OutputField
										outputLabel={t('label.address')}
										outputText={entityData.address ? entityData.address : ''}
									/>
									{/* <div className="flex-inline" style={{ alignItems: 'flex-end' }}> */}
									<div className="postal-locality">
										<OutputField
											outputLabel={t('label.postalCode')}
											outputText={
												entityData.postalCodePrefix && entityData.postalCodeSuffix
													? entityData.postalCodePrefix + '-' + entityData.postalCodeSuffix
													: ''
											}
										/>
										<OutputField
											outputLabel={t('label.locality')}
											outputText={entityData.locality ? entityData.locality : ''}
										/>
									</div>
								</>
							)}
						/>
					</FieldsFormContainer>
				</div>
				<div className="bottom-88pt">
					<FieldsFormContainer>
						<TitleContainer
							text={t('titleContainer.entityData.preferredContact')}
							content={(): React.ReactNode => (
								<>
									<p className="descriptions">{t('descriptions.entityData.preferredContact')}</p>
									<OutputField
										outputLabel={t('label.name')}
										outputText={
											entityData.preferredContactName ? entityData.preferredContactName : ''
										}
									/>
									<OutputField
										outputLabel={t('label.email')}
										outputText={
											entityData.preferredContactEmail ? entityData.preferredContactEmail : ''
										}
									/>
									<OutputField
										outputLabel={t('label.phone')}
										outputText={
											entityData.preferredContactPhonePrefix &&
											entityData.preferredContactPhoneNumber
												? entityData.preferredContactPhonePrefix +
												  entityData.preferredContactPhoneNumber
												: ''
										}
									/>
								</>
							)}
						/>
					</FieldsFormContainer>
				</div>
				<div className="bottom-88pt">
					<FieldsFormContainer>
						<TitleContainer
							text={t('titleContainer.entityData.entityDocumentation')}
							content={() => (
								<>
									<p className="descriptions">{t('descriptions.entityData.entityDocumentation')}</p>
									<div className="ds-form-radio-horizontal" style={{ marginBottom: '4rem' }}>
										<div
											className={`${
												selectedRadio !== SubscriptionTypes.oneSubscription
													? 'not-selected'
													: ''
											}`}
											style={{ marginRight: '2.5rem' }}
										>
											<RadioButton
												isDisabled={true}
												isChecked={selectedRadio === SubscriptionTypes.oneSubscription}
												id={CoreHelper.guid()}
												value={SubscriptionTypes.oneSubscription}
												labelText={t('radioButton.oneSubscription')}
											></RadioButton>
										</div>
										<div
											className={`${
												selectedRadio !== SubscriptionTypes.moreThanOneSubscription
													? 'not-selected'
													: ''
											}`}
										>
											<RadioButton
												isChecked={selectedRadio === SubscriptionTypes.moreThanOneSubscription}
												isDisabled={true}
												id={CoreHelper.guid()}
												value={SubscriptionTypes.moreThanOneSubscription}
												labelText={t('radioButton.moreThanOneSubscription')}
											></RadioButton>
										</div>
									</div>
									{checkIfIsPrivateNipc(entityData.nipc ?? '0') ||
									entityData.typePermanentCertificate === 'file' ? (
										<OutputField
											outputLabel={
												checkIfIsPrivateNipc(entityData.nipc ?? '0')
													? t('label.entityData.addressCertificate')
													: t('label.entityData.permanentCertificateFile')
											}
											// additionalContent={() => (
											// 	<span className="ds-text-link-files">
											// 		{evidenceFile ? evidenceFile.fileName : ''}
											// 	</span>
											// )}
											additionalContent={() => (
												// <span className="ds-text-link-files">
												// 	{ibanFile ? ibanFile.fileName : ''}
												// </span>
												<span className="ds-text-link-files">
													{evidenceFile && evidenceFile.id ? (
														<LinkLabel
															className="ds-text-link-appearance-2-underline"
															text={evidenceFile ? evidenceFile.fileName : '-'}
															target="_blank"
															onClick={() => this.downloadDocument(evidenceFile.id)}
														/>
													) : (
														'-'
													)}
												</span>
											)}
										/>
									) : (
										''
									)}
									{entityData.typePermanentCertificate === 'code' ? (
										<OutputField
											outputLabel={t('label.entityData.permanentCertificateCode')}
											outputText={
												entityData.permanentCertificateCode
													? entityData.permanentCertificateCode
													: ''
											}
										/>
									) : (
										''
									)}
								</>
							)}
						/>
					</FieldsFormContainer>
				</div>
				<div className="bottom-88pt">
					<FieldsFormContainer>
						<TitleContainer
							text={t('titleContainer.service-charge.title')}
							content={(): React.ReactNode => (
								<>
									<p className="descriptions">{t('titleContainer.service-charge.description')}</p>
									<OutputField
										outputLabel={t('titleContainer.service-charge.label.iban-number')}
										outputText={entityData.ibanNumber ? entityData.ibanNumber : ''}
									/>
									<OutputField
										outputLabel={t('titleContainer.service-charge.label.iban-proof-file')}
										additionalContent={() => (
											// <span className="ds-text-link-files">
											// 	{ibanFile ? ibanFile.fileName : ''}
											// </span>
											<span className="ds-text-link-files">
												{ibanFile && ibanFile.id ? (
													<LinkLabel
														className="ds-text-link-appearance-2-underline"
														text={ibanFile ? ibanFile.fileName : '-'}
														target="_blank"
														onClick={() => this.downloadDocument(ibanFile.id)}
													/>
												) : (
													'-'
												)}
											</span>
										)}
									/>
								</>
							)}
						/>
					</FieldsFormContainer>
				</div>
				<div className="bottom-88pt">
					<FieldsFormContainer>
						<TitleContainer
							text={t('titleContainer.entityData.usersData')}
							content={(): React.ReactNode => (
								<p className="descriptions">{t('descriptions.userData.userData')}</p>
							)}
						/>
					</FieldsFormContainer>
				</div>
				<div className="bottom-88pt table">
					<TitleContainer
						hasGrayBackground
						text={t('table.registerPharmacy.users')}
						content={(): React.ReactNode => (
							<>
								<Table
									columnsWidth={[ColType.extraBig, ColType.extraBig, ColType.extraBig]}
									appearance={TableAppearance.primary}
									withCheckbox={canEditUsers}
									withSuffix
									hasError
									headers={headings}
									rows={rows}
									onChange={this.handleChange}
									onDetailsClick={onClickToViewUserDetail}
								/>
							</>
						)}
					/>
					<div
						style={{
							display: 'flex',
							marginTop: '1.5rem',
							alignItems: 'flex-end',
							flexDirection: 'row',
							justifyContent: 'space-between',
						}}
					>
						<div></div>
						{canEditUsers ? (
							<div className="users-options-list">
								<LinkLabel
									className={`${'ds-text-link'}`}
									text={t('link.registerPharmacy.removeUser')}
									icon="ic-apagar-before"
									onClick={this.removeUsers}
									hasAppearance
								/>
								<LinkLabel
									className={`${'ds-text-link'}`}
									text={t('link.registerPharmacy.addUser')}
									onClick={onClickCreatingUser}
									icon="ic-adicionar-before"
									hasAppearance
								/>
							</div>
						) : (
							''
						)}
					</div>
				</div>
				{!canEditUsers ? (
					<div className="final-step-container">
						<p className="title-bold"> {t('registerPharmacy.contractShipping.titles.finishAdherence')}</p>

						<div className="indicator-steps">
							<div>
								{t('registerPharmacy.contractShipping.subTitles.step1')}
								<span>
									<LinkLabel
										className="indicator-steps-download"
										text={'download'} // {document.fileName ?? '-'}
										target="_blank"
										onClick={this.downloadContractDocument}
									/>
								</span>
								{/* <a className="indicator-steps-download">download</a> */}
								{t('registerPharmacy.contractShipping.subTitles.step1_5')}
							</div>
							<p>{t('registerPharmacy.contractShipping.subTitles.step2')}</p>
							<p>{t('registerPharmacy.contractShipping.subTitles.step3')}</p>
							<p>{t('registerPharmacy.contractShipping.subTitles.step4')}</p>
							<p>{t('registerPharmacy.contractShipping.subTitles.step5')}</p>
						</div>
						<Formik
							initialValues={{
								adherenceFile: {
									id: '',
									name: '',
									type: '',
									base64File: '',
								},
							}}
							validationSchema={submitContractSchema({ t })}
							onSubmit={(values: { adherenceFile: FileUploadType }, { setSubmitting }): void => {
								// const { adherenceFile } = values;

								// if (adherenceFile.type && adherenceFile.base64File) {
								// 	fetchUploadFileExecutionRequest(adherenceFile, {
								// 		successHandler: (fileId: string) => {
								// 			const stepInputData: RegisterInputData = {
								// 				usersData: entityData.usersData,
								// 			};
								// 			onClickNext(stepInputData);
								// 		},
								// 	});
								// }

								onClickNext(undefined);
								setSubmitting(false);
							}}
						>
							{({ isSubmitting, getFieldMeta, setFieldValue, values, validateForm }): FormikValues => (
								<Form>
									<div className="file-field-width">
										<Field
											component={FileField}
											name="adherenceFile"
											buttonText={t('buttons.general.select')}
											fileFieldLabel={t<string>(
												'inputs.fileField.registerPharmacy.signedDocument'
											)}
											handleFile={(file: TemporaryFile, action: FileAction): void => {
												// eslint-disable-nest-line no-debugger
												// handle our handle change with all info and formik setFieldValue
												this.handleFileChange(
													file,
													action,
													values.adherenceFile,
													'adherenceFile',
													setFieldValue
												);
											}}
											hasError={getFieldMeta('adherenceFile').error}
											errorMessage={t('errors.form.required')}
											nrAllowedFiles={1}
											filesMaxSize={FileUploadConfig.maxFileSizeBytes}
											showAttachmentSizeInfoModal={(text: string): void => {
												modalOpen(
													BuildOkInfoModal(
														t(text, {
															maxSize: FileUploadConfig.maxFileSizeMegaBytes,
														}),
														'Ok'
													)
												);
											}}
											showAttachmentsNumberInfoModal={(text: string): void => {
												modalOpen(BuildOkInfoModal(t(text, { maxNumber: 1 }), 'Ok'));
											}}
										/>
									</div>
									<FieldsFormContainer>
										<div style={{ marginBottom: '3rem' }} className="final-buttons">
											{/* <div style={{ marginRight: '2rem' }}> */}
											<Button
												primary
												text={t('buttons.registerPharmacy.sendAdherence')}
												type="submit"
											/>
											{/* </div> */}
											{/* <Button
												tertiary
												text={t('buttons.general.cancel')}
												onClick={onClickCancel}
											/> */}

											<Button
												tertiary
												text={t('general.button.cancel')}
												onClick={event => {
													event.preventDefault();
													onClickCancel && onClickCancel();
												}}
											/>
										</div>
									</FieldsFormContainer>
								</Form>
							)}
						</Formik>
					</div>
				) : (
					''
				)}
				<div className="bottom-88px bottom-multiple-buttons">
					{canEditUsers ? (
						<>
							<div className="margin-right-button">
								<Button
									primary
									text={t('general.button.continue')}
									onClick={() => {
										const isValid = this.validateUsers();
										if (isValid) {
											// const stepInputData: RegisterInputData = {
											// 	usersData: entityData.usersData,
											// };
											const stepInputData: StepRegisterInputData = {
												stepIndex: 3,
												registerInputData: undefined,
												// {
												// 	usersData: entityData.usersData,
												// },
											};
											onClickNext(stepInputData);
										} else {
											modalOpen(
												BuildCustomMessageGenericErrorModal('pt', t('modals.noAuthorizedUsers'))
											);
										}
									}}
									disabled={rows.length === 0}
								/>
							</div>
							<div className="margin-right-button">
								{/* <Button tertiary text={t('general.button.cancel')} onClick={onClickCancel} /> */}

								<Button
									tertiary
									text={t('general.button.cancel')}
									onClick={event => {
										event.preventDefault();
										onClickCancel && onClickCancel();
									}}
								/>
							</div>
						</>
					) : (
						''
					)}
					<Button
						tertiary
						text={t('general.button.back')}
						onClick={event => {
							event.preventDefault();
							onClickBack(undefined);
						}}
						// onClick={onClickBack}
					/>
				</div>
				{/* </div> */}
				{/* </div> */}
			</PageScreen>
		);
	}

	private handleFileChange = (
		file: TemporaryFile,
		action: FileAction,
		currentFile: FileUploadType,
		fieldName: string,
		setFormikInputValue: (field: string, value: FileUploadType, shouldValidate?: boolean) => void
	): void => {
		if (action === FileAction.Add) {
			if (!file.error) {
				const { fetchUploadFileExecutionRequest } = this.props;

				currentFile = {
					id: file.id,
					name: file.file.name,
					type: file.file.type,
					base64File: file.base64File,
					inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CONTRACT.toString(),
				};

				const { type, base64File } = currentFile;
				if (type && base64File) {
					fetchUploadFileExecutionRequest(currentFile);
				}
			}
		} else if (action === FileAction.Remove) {
			currentFile = {
				id: '',
				name: '',
				type: '',
				base64File: '',
			};
		}

		setFormikInputValue(fieldName, currentFile, false);
	};

	private validateUsers = (): boolean => {
		const { entityData } = this.props;

		if (!entityData.usersData) {
			return false;
		}

		const authorizedCount = entityData.usersData.filter(
			u => u.profileAccess === EnrollmentTypes.UserProfile.AUTHORIZED
		).length;

		return authorizedCount > 0;
	};

	private removeUsers = (): void => {
		const { selectedUsers } = this.state;
		const { removeUserData, fetchUpdateRegisterData } = this.props;

		//debugger;
		selectedUsers.forEach(u => {
			removeUserData(u.id);
		});
		this.setState({ selectedUsers: [] });

		const stepInputData: StepRegisterInputData = {
			stepIndex: 2,
			registerInputData: undefined,
		};
		fetchUpdateRegisterData && fetchUpdateRegisterData(stepInputData);
	};

	private readonly handleChange = (rows: any): void => {
		this.setState({
			...this.state,
			selectedUsers: rows,
		});
	};

	private isRowSelected(idString: string): boolean {
		const { selectedUsers } = this.state;

		const selectedRows = [...selectedUsers];

		if (selectedRows.length !== 0) {
			const aux = selectedRows.find(x => x.id === idString);
			if (aux && aux.isSelected) {
				return true;
			}
		}
		return false;
	}

	private downloadContractDocument = (): void => {
		const { fetchDownloadContractFileRequest } = this.props;

		fetchDownloadContractFileRequest({
			successHandler: (file: EnrollmentTypes.File) => {
				if (file.data && file.name) {
					downloadFilePdf(file.data as string, file.name);
				}
			},
		});
	};

	private downloadDocument = (fileId: string): void => {
		const { fetchDownloadRegisterDocumentByIdRequest } = this.props;
		fetchDownloadRegisterDocumentByIdRequest(fileId, {
			successHandler: (file: EnrollmentTypes.File) => {
				if (file.data && file.name) {
					downloadFilePdf(file.data as string, file.name);
				}
			},
		});
	};
}

const mapStateToProps = (state: StoreState): object => ({
	entityData: getRegisterPharmacyInputData(state),
	processFlow: getProcessFlow(state),
});

const mapDispatchToProps = (dispatch: any): object =>
	bindActionCreators(
		{
			modalOpen,
			removeUserData,
			removeUploadFileExecution,
			fetchUploadFileExecutionRequest,
			fetchDownloadContractFileRequest,
			fetchDownloadRegisterDocumentByIdRequest,
		},
		dispatch
	);

export const EntityDataConfirmationScreen = WithCoreProps<EntityDataConfirmationProps>(
	connect(mapStateToProps, mapDispatchToProps)(EntityDataConfirmationScreenComponent)
);
